export default "__VITE_ASSET__DdO8mBL3__"